const gregorianToPersian = (date) => {
    let g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

    let sp = date.split('-');
    let g = [parseInt(sp[0]), parseInt(sp[1]), parseInt(sp[2])];

    let gy, gm, gd;
    let jy, jm, jd;
    let g_day_no, j_day_no;
    let j_np;

    let i;

    gy = g[0] - 1600;
    gm = g[1] - 1;
    gd = g[2] - 1;

    g_day_no = 365 * gy + div((gy + 3), 4) - div((gy + 99), 100) + div((gy + 399), 400);

    for (i = 0; i < gm; ++i)
        g_day_no += g_days_in_month[i];

    if (gm > 1 && ((gy % 4 == 0 && gy % 100 != 0) || (gy % 400 == 0)))
        /* leap and after Feb */
        ++g_day_no;
    g_day_no += gd;

    j_day_no = g_day_no - 79;

    j_np = div(j_day_no, 12053);
    j_day_no = remainder(j_day_no, 12053);

    jy = 979 + 33 * j_np + 4 * div(j_day_no, 1461);
    j_day_no = remainder(j_day_no, 1461);


    if (j_day_no >= 366) {
        jy += div((j_day_no - 1), 365);
        j_day_no = remainder((j_day_no - 1), 365);
    }

    for (i = 0; i < 11 && j_day_no >= j_days_in_month[i]; ++i) {
        j_day_no -= j_days_in_month[i];
    }

    jm = i + 1;
    jd = j_day_no + 1;

    return `${jy}-${fixDate(jm)}-${fixDate(jd)}`;
}

const persianToGregorian = (date) => {
    let g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

    let sp = date.split('-');
    let g = [parseInt(sp[0]), parseInt(sp[1]), parseInt(sp[2])];

    let j_y = g[0];
    let j_m = g[1];
    let j_d = g[2];

    let jy = j_y - 979;
    let jm = j_m - 1;
    let jd = j_d - 1;
    let j_day_no = 365 * jy + Math.floor(jy / 33) * 8 + Math.floor((jy % 33 + 3) / 4);
    for (let i = 0; i < jm; ++i) {
        j_day_no += j_days_in_month[i];
    }
    j_day_no += jd;
    let g_day_no = j_day_no + 79;
    let gy = 1600 + 400 * Math.floor(g_day_no / 146097);
    g_day_no = g_day_no % 146097;
    let leap = true;
    if (g_day_no >= 36525) {
        g_day_no--;
        gy += 100 * Math.floor(g_day_no / 36524);
        g_day_no = g_day_no % 36524;
        if (g_day_no >= 365) {
            g_day_no++;
        } else {
            leap = false;
        }
    }
    gy += 4 * Math.floor(g_day_no / 1461);
    g_day_no %= 1461;
    if (g_day_no >= 366) {
        leap = false;
        g_day_no--;
        gy += Math.floor(g_day_no / 365);
        g_day_no = g_day_no % 365;
    }
    let i;
    for (i = 0; g_day_no >= g_days_in_month[i] + (i == 1 && leap); i++) {
        g_day_no -= g_days_in_month[i] + (i == 1 && leap);
    }
    let gm = i + 1;
    let gd = g_day_no + 1;

    return `${gy}-${fixDate(gm)}-${fixDate(gd)}`;
}

function div(a, b) {
    return Math.floor(a / b);
}

function remainder(a, b) {
    return a - div(a, b) * b;
}

function fixDate(number) {
    let result = (Math.floor(number / 10) == 0) ? '0' + number : number;
    return result;
}

const DateTime = {
    gregorianToPersian,
    persianToGregorian
}

export default DateTime;
